import { createContext } from 'react';

import { AppContextIF } from '../interfaces/appContext/appContext.interface';


export const AppContext = createContext<AppContextIF>({} as AppContextIF);